import React from 'react'
import PropTypes from 'prop-types'

function CurvedArrow({ fill, stroke, className, height, width }) {
  return (
    <svg viewBox="0 0 29 34" height={height} width={width} className={className}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M.185 7.916c-.427.594-.09 1.081.75 1.081L11.617 9c.84 0 1.165-.48.72-1.066L6.902.77C6.458.182 5.744.189 5.316.784z"
          fill={fill}
        />
        <path
          d="M27 32C15.455 32 6.097 21.486 6.097 8.516"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={3}
        />
      </g>
    </svg>
  )
}

CurvedArrow.propTypes = {
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
}

export default CurvedArrow
